import {Fragment, useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {
  INDEX_PAGE_SIZE_DEFAULT,
  INDEX_PAGE_SIZE_OPTIONS,
} from '../../../../../../shared/constants/AppConst';
import {CheckIsUpdateOrCreateRow} from '../../../../../../shared/common-dtos/check-is-update-or-create-row';
import {BannerProductListDto} from '../../../../../../shared/services/banners/dto/banner-product-list-dto';
import {bannersService} from '../../../../../../shared/services/banners';
import {useParams} from 'react-router-dom';
import {popupConfirm} from '../../../../../../shared/components/popup-confirm';
import ColumnsData from './columns';
import {BannersListDto} from '../../../../../../shared/services/banners/dto/banners-list-dto';
import {Formik} from 'formik';
import {Form, Table} from 'formik-antd';
import {PorductVariantSkuDto} from '../../../../../../shared/services/banners/dto/porduct-variant-sku-dto';
import {BannerProductInsertDto} from '../../../../../../shared/services/banners/dto/banner-product-insert-dto';
import useTableV2 from '../../../../../../shared/hooks/useTableV2';

interface IBannerPoductsListProps {
  mainCategoryId: string;
  bannerDetails: BannersListDto;
}

const BannerPoductsList = (props: IBannerPoductsListProps) => {
  const {mainCategoryId, bannerDetails} = props;

  const {id} = useParams();
  const {messages} = useIntl();
  const {showTotal, ...tableV2} = useTableV2();
  const [bannerPoductsList, setBannerPoductsList] = useState<
    BannerProductListDto[]
  >([]);
  const [bannerPoductsListTotal, setBannerPoductsListTotal] = useState(0);
  const [isBannerPoductsListLoading, setBannerPoductsListLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState<number>(INDEX_PAGE_SIZE_DEFAULT);
  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);
  const [currentPage, setCurrentPage] = useState(1);
  const [update, setUpdate] = useState<CheckIsUpdateOrCreateRow>({
    id: undefined,
    update: undefined,
    createNew: false,
  });
  const [isCreateNewBannerPoductLoading, setIsCreateNewBannerPoductLoading] =
    useState(false);
  const [productDetailsListLodaing, setProductDetailsListLodaing] =
    useState(false);
  const [productDetailsList, setProductDetailsList] = useState<
    PorductVariantSkuDto[]
  >([]);
  const [productSelected, setProductSelected] = useState('');

  useEffect(() => {
    if (id)
      (async () => {
        try {
          setBannerPoductsListLoading(true);
          let productList = await bannersService.getBannerProductList(id);
          setBannerPoductsList(productList);
          setBannerPoductsListTotal(productList?.length);
        } catch (error) {
          console.error(error);
        } finally {
          setBannerPoductsListLoading(false);
        }
      })();
  }, [id, mainCategoryId]);

  useEffect(() => {
    if (productSelected) {
      (async () => {
        try {
          setProductDetailsListLodaing(true);
          let productInfo =
            await bannersService.getPorductVariantSkuByProductId(
              productSelected,
            );
          setProductDetailsList(productInfo ?? []);
        } catch (error) {
          console.error(error);
        } finally {
          setProductDetailsListLodaing(false);
        }
      })();
    }
  }, [productSelected]);

  const getBannerProductsList = async () => {
    try {
      setBannerPoductsListLoading(true);
      let productList = await bannersService.getBannerProductList(id ?? '');
      setBannerPoductsList(productList);
      setBannerPoductsListTotal(productList?.length);
    } catch (error) {
      console.error(error);
    } finally {
      setBannerPoductsListLoading(false);
    }
  };

  const pagination = {
    total: bannerPoductsListTotal,
    pageSizeOptions: pageSizeOptions,
    pageSize: pageSize,
    showSizeChanger: true,
    showTotal,
    current: currentPage,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPageSize(PageSize);
    },
    onChange: async (page: any) => {
      setCurrentPage(page);
    },
  };

  const handleCreateNewRow = (index: number) => {
    setUpdate({
      id: index,
      update: undefined,
      createNew: true,
    });
  };

  const handleRemoveNewRow = () => {
    setUpdate({
      id: undefined,
      update: undefined,
      createNew: false,
    });
  };

  const handleCreateNewBannerProduct = async (
    record: BannerProductInsertDto,
  ) => {
    try {
      setIsCreateNewBannerPoductLoading(true);
      await bannersService.bannerProductInsert({
        ...record,
        banId: id ?? '',
      });
      await getBannerProductsList();
      handleRemoveNewRow();
    } catch (error) {
      console.error(error);
    } finally {
      setIsCreateNewBannerPoductLoading(false);
    }
  };

  const deleteBannerProduct = (record: BannerProductListDto) => {
    popupConfirm(async () => {
      try {
        await bannersService.bannerProductDelete({
          productId: record?.ProductId,
          banId: id ?? '',
        });
        await getBannerProductsList();
      } catch (error) {
        console.error(error);
      }
    }, `${messages['commom.areYouSureYouWantToDelete'].toString()}` + ' ' + [messages['common.thisRecord'].toString()] + `?`);
  };

  return (
    <Fragment>
      <Formik
        initialValues={{item: bannerPoductsList}}
        enableReinitialize
        onSubmit={() => {}}>
        {(formProps) => (
          <Form onFinish={formProps.handleSubmit}>
            <Table
              name='item'
              rowKey={(record: BannerProductListDto) =>
                record?.Id?.toString() ?? ''
              }
              pagination={pagination}
              loading={isBannerPoductsListLoading}
              {...tableV2}
              columns={ColumnsData(
                formProps,
                update,
                bannerDetails,
                mainCategoryId,
                productDetailsList,
                productDetailsListLodaing,
                productSelected,
                setProductSelected,
                handleCreateNewRow,
                isCreateNewBannerPoductLoading,
                handleCreateNewBannerProduct,
                handleRemoveNewRow,
                deleteBannerProduct,
              )}
            />
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

export default BannerPoductsList;
